import { createMetricsPlugin } from "./plugins/metrics";
import { createBookingMetricsPlugin } from "./plugins/booking-metrics";
import { createFullscreenCarouselPlugin } from "./plugins/fullscreen-lightbox";
import { createFetchHtmlPlugin } from "./plugins/fetch-html";
import { createIframePlugin } from "./plugins/iframe";
import { createLivePlugin } from "./plugins/live";
import { createTooltipPlugin } from "./plugins/tooltip";
import { createExperiencePlugin } from "./plugins/experience";

document.addEventListener("alpine:init", () => {
  createTooltipPlugin();
  createIframePlugin();
  createMetricsPlugin();
  createBookingMetricsPlugin();
  createLivePlugin();
  createExperiencePlugin();
  createFullscreenCarouselPlugin();
  createFetchHtmlPlugin();
});
